import { useQuery } from '@tanstack/react-query';

import { getOrderDocuments } from '~/services/OrderDocumentService';

export const orderDocumentQueryKeys = {
  all: ['orderDocuments'] as const,
  lists: () => [...orderDocumentQueryKeys.all, 'list'] as const,
  list: (orderId: string) => [...orderDocumentQueryKeys.lists(), orderId] as const,
};

function sortDocuments(documents: Array<App.OrderDocument>): Array<App.OrderDocument> {
  return [...documents].sort((a, b) => {
    const dateA = new Date(a.created_at).getTime();
    const dateB = new Date(b.created_at).getTime();
    return dateB - dateA;
  });
}

export function useGetOrderDocuments(orderId: string) {
  return useQuery({
    queryKey: orderDocumentQueryKeys.list(orderId),
    queryFn: () => getOrderDocuments(orderId),
    enabled: !!orderId,
    select: (data) => sortDocuments(data),
  });
}
